<div class="alert-panel flex grid-gap-10" [ngClass]="'alert-panel--' + severity">
  <i class="fa alert-panel-icon" [ngClass]="icon"></i>
  <div class="flex-grow-1">
    <div class="alert-panel-title" *ngIf="heading">{{ heading }}</div>
    <ng-content></ng-content>
  </div>
</div>
